import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ReadReceipt = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_1126_176963)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2.5C2 1.67157 2.67157 1 3.5 1H12.5C13.3284 1 14 1.67157 14 2.5V7C14 7.27614 13.7761 7.5 13.5 7.5C13.2239 7.5 13 7.27614 13 7V2.5C13 2.22386 12.7761 2 12.5 2H3.5C3.22386 2 3 2.22386 3 2.5V13.5C3 13.7761 3.22386 14 3.5 14H6C6.27614 14 6.5 14.2239 6.5 14.5C6.5 14.7761 6.27614 15 6 15H3.5C2.67157 15 2 14.3284 2 13.5V2.5ZM4.5 5C4.5 4.72386 4.72386 4.5 5 4.5H11C11.2761 4.5 11.5 4.72386 11.5 5C11.5 5.27614 11.2761 5.5 11 5.5H5C4.72386 5.5 4.5 5.27614 4.5 5ZM5 7.5C4.72386 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.72386 8.5 5 8.5H9C9.27614 8.5 9.5 8.27614 9.5 8C9.5 7.72386 9.27614 7.5 9 7.5H5Z"
            fill={color}
          />
          <path
            d="M7 11.6667L9.85714 15L15 9"
            stroke={color}
            fill="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1126_176963">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default ReadReceipt
